import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Faq } from "../models/faq.model";

@Injectable({
  providedIn: 'root'
})
export class FaqService {

  private readonly ENDPOINT = '/Faq/'
  constructor(private http: HttpClient) {
  }

  private apiUrl() {
    return environment.apiUrl + this.ENDPOINT;
  }

  setOrder(trialId: string, faqIds: string[]) {
    return this.http.post<Faq[]>(this.apiUrl() + 'trial/' + trialId + '/setOrder', faqIds)
      .pipe(
        map(response => {
          return response.map(item => new Faq(item));
        })
      );;
  }

  remove(faqId: string) {
    return this.http.delete<Faq[]>(this.apiUrl() + faqId)
      .pipe(
        map(response => {
          return response.map(item => new Faq(item));
        })
      );;
  }

  update(faqId: string, faq: Faq) {
    return this.http.put<Faq[]>(this.apiUrl() + faqId, faq)
      .pipe(
        map(response => {
          return response.map(item => new Faq(item));
        })
      );;
  }

  add(trialId: string, faq: Faq) {
    return this.http.post<Faq[]>(this.apiUrl() + 'trial/' + trialId, faq)
      .pipe(
        map(response => {
          return response.map(item => new Faq(item));
        })
      );;
  }

  list(trialId: string): Observable<Faq[]> {
    return this.http.get<Faq[]>(this.apiUrl() + 'trial/' + trialId)
      .pipe(
        map(response => {
          return response.map(item => new Faq(item));
        })
      );
  }
}
